import {forwardRef} from "react";

import {FieldErrorIcon} from "../../atoms/FieldErrorIcon";
import {FieldWrapper, IFieldWrapperProps} from "../../atoms/wrapper/FieldWrapper";
import {getFieldState} from "../../field_state_helper";
import {getErrorMessage} from "../../utils/get_error_message";
import {Input, ITextInputProps} from "./Input";

export type IInputFieldProps = IFieldWrapperProps &
    ITextInputProps & {
        error?: string | string[];
    };

export const InputField = forwardRef<HTMLInputElement, IInputFieldProps>((props: IInputFieldProps, inputForwardedRef) => {
    const {labelContent, message, id, className, onChange, error, errorMessageVariant = "default", rightElement, ...inputProps} = props;

    const fieldState = getFieldState(props);
    const errorMessage = getErrorMessage(error);
    const shouldShowAlternativeErrorIcon = errorMessageVariant === "alternative" && fieldState === "error" && !!errorMessage;

    return (
        <FieldWrapper
            className={className}
            errorMessageVariant={errorMessageVariant}
            fieldState={fieldState}
            htmlFor={id}
            labelContent={labelContent}
            message={errorMessage || message}
        >
            <Input
                {...inputProps}
                errorMessageVariant={errorMessageVariant}
                fieldState={fieldState}
                id={id}
                inputForwardedRef={inputForwardedRef}
                onChange={onChange}
                rightElement={shouldShowAlternativeErrorIcon ? <FieldErrorIcon /> : rightElement}
            />
        </FieldWrapper>
    );
});
import {forwardRef} from "react";

import {FieldErrorIcon} from "../../atoms/FieldErrorIcon";
import {FieldWrapper, IFieldWrapperProps} from "../../atoms/wrapper/FieldWrapper";
import {getFieldState} from "../../field_state_helper";
import {getErrorMessage} from "../../utils/get_error_message";
import {Input, ITextInputProps} from "./Input";

export type IInputFieldProps = IFieldWrapperProps &
    ITextInputProps & {
        error?: string | string[];
    };

export const InputField = forwardRef<HTMLInputElement, IInputFieldProps>((props: IInputFieldProps, inputForwardedRef) => {
    const {labelContent, message, id, className, onChange, error, errorMessageVariant = "default", rightElement, ...inputProps} = props;

    const fieldState = getFieldState(props);
    const errorMessage = getErrorMessage(error);
    const shouldShowAlternativeErrorIcon = errorMessageVariant === "alternative" && fieldState === "error" && !!errorMessage;

    return (
        <FieldWrapper
            className={className}
            errorMessageVariant={errorMessageVariant}
            fieldState={fieldState}
            htmlFor={id}
            labelContent={labelContent}
            message={errorMessage || message}
        >
            <Input
                {...inputProps}
                errorMessageVariant={errorMessageVariant}
                fieldState={fieldState}
                id={id}
                inputForwardedRef={inputForwardedRef}
                onChange={onChange}
                rightElement={shouldShowAlternativeErrorIcon ? <FieldErrorIcon /> : rightElement}
            />
        </FieldWrapper>
    );
});
